import { jsx as t, jsxs as l, Fragment as x } from "react/jsx-runtime";
import { TooltipTextContainer as T } from "./style.js";
import { Tooltip as c } from "../index.js";
const d = ({
  children: r,
  icon: o,
  className: e,
  content: n,
  openTo: i,
  childrenRef: m,
  isVisible: p
}) => /* @__PURE__ */ t(
  c,
  {
    content: /* @__PURE__ */ l(x, { children: [
      o && o,
      /* @__PURE__ */ t(T, { children: n })
    ] }),
    openTo: i,
    childrenRef: m,
    className: e,
    isVisible: p,
    children: r
  }
);
export {
  d as TextIconTooltip
};
